import { blankToNull } from '../../../utils'

export function validate(record) {
  const errors = []

  if (!record.descricao) {
    errors.push({
      field: 'descricao',
      message: 'Descrição deve ser informada',
    })
  }

  if (!record.configuracaoPixAutomatico || !record.configuracaoPixAutomatico.id) {
    errors.push({
      field: 'configuracaoPixAutomatico',
      message: 'Configuração de Pix Automático deve ser informada',
    })
  }

  if (!record.tipo) {
    errors.push({
      field: 'tipo',
      message: 'Tipo de webhook deve ser informado',
    })
  }

  blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
